import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppState } from '../../../store';

import Sentry from '../../../monitoring/sentry';

const SentryContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { allowed_drugstores, current_drugstore } = useSelector(({ permissions }: AppState) => permissions);
  // eslint-disable-next-line no-shadow
  const { user } = useSelector(({ user }: AppState) => user);

  useEffect(() => {
    if (user.id && allowed_drugstores.length) {
      Sentry.setDrugstoreUser(user, current_drugstore);
    }
  }, [user, allowed_drugstores, current_drugstore, dispatch]);

  return <></>;
};

export default SentryContainer;
